import { IHeadLabel, ISort } from "../types/table";

const systemOrderOptions: ISort[] = [
    {
        label: "Nome Crescente",
        direction: "asc",
        sortBy: "Name"
    },
    {
        label: "Nome Decrescente",
        direction: "desc",
        sortBy: "Name"
    },
    {
        label: "Cadastro Crescente",
        direction: 'asc',
        sortBy: 'Id'
    },
    {
        label: "Cadastro Decrescente",
        direction: 'desc',
        sortBy: 'Id'
    }
];

const columnsSystemTable: IHeadLabel[] = [
    {
        label: "ID",
    },
    {
        label: "Nome"
    },
    {
        label: "Ativo"
    },
    {
        label: "",
        align: "right"
    }
];

export {
    columnsSystemTable,
    systemOrderOptions
}